import { API_BASE_URL } from "src/config/api";
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Stack,
  Avatar,
  Chip,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { format } from 'date-fns';

export default function LastFiveAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAlerts = async () => {
    try {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token')?.replace(/"/g, '');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { userId },
      };

      const res = await axios.get(`${API_BASE_URL}/getLastFiveAlertByUserId`, config);
      if (res.data.success) {
        setAlerts(res.data.alerts || []);
      }
    } catch (error) {
      console.error('Error fetching alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAlerts();
  }, []);

  const getIcon = (status) => {
    if (status === 'resolved') return <CheckCircleIcon color="success" />;
    if (status === 'firing') return <WarningAmberIcon color="error" />;
    return <AutorenewIcon color="primary" />;
  };

  const getLabelColor = (status) => {
    if (status === 'resolved') return 'success';
    if (status === 'firing') return 'error';
    return 'default';
  };

  return (
    <Card sx={{ height: '484px' }}>
      <CardHeader
        title="Last 5 Alerts"
        subheader="Your latest five alerts interactions and events"
      />
      <CardContent sx={{ p: 0 }}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" height={100}>
            <CircularProgress size={24} />
          </Box>
        ) : alerts.length === 0 ? (
          <Box display="flex" justifyContent="center" alignItems="center" height="350px">
            <Typography variant="body2" color="text.secondary" textAlign="center">
              No alerts found
            </Typography>
          </Box>
        ) : (
          <Stack
            spacing={2}
            sx={{
              maxHeight: '420px', // fits under card header
              overflowY: 'auto',
              p: 2,
              pr: 1.5, // avoid scrollbar overlapping text
            }}
          >
            {alerts.map((alert, idx) => (
              <Box
                key={alert._id || idx}
                display="flex"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box display="flex" alignItems="center">
                  <Avatar sx={{ bgcolor: 'transparent', mr: 2 }}>
                    {getIcon(alert.status)}
                  </Avatar>
                  <Box>
                    <Typography variant="subtitle2">{alert.alertname}</Typography>
                    <Typography variant="body2">{alert.annotations?.description}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {format(new Date(alert.receivedAt), 'dd MMM yyyy, hh:mm a')}
                    </Typography>
                  </Box>
                </Box>
                <Chip
                  label={alert.status}
                  color={getLabelColor(alert.status)}
                  size="small"
                  variant="outlined"
                />
              </Box>
            ))}
          </Stack>
        )}
      </CardContent>
    </Card>
  );
}
